import type { MeasureMode } from "../types";

export function createLeafletMeasure(map: any, mode: MeasureMode) {
  return {
    activate() {
      console.log("Activating Leaflet measure mode:", map, mode);
    },

    deactivate() {},
  };
}
